import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import { notification } from '../../component/hocs/notification';

import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';

import axios from 'axios';
import { mainurl } from '../../Mainurl';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    InputGroup,
    InputGroupText,
    Label, 
    Button, 
    Form, 
    Modal, 
    ModalHeader, 
    ModalBody,
    Badge,
    Spinner,
    Alert
} from 'reactstrap';

import { 
    FaPlusCircle, 
    FaSearch, 
    FaList, 
    FaSeedling, 
    FaCalendarAlt, 
    FaEye,
    FaLeaf,
    FaClipboardList
} from 'react-icons/fa';
import AddNewPOP from '../../component/utility/setting/AddNewPOP';

const PackageOfPractice = () => {
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState(1);
    const [cropTypeOpt, setCropTypeOpt] = useState('');
    const [cropType, setCropType] = useState('');
    const [cropOpt, setCropOpt] = useState('');
    const [crop, setCrop] = useState('');
    const [cropVarietyOpt, setCropVarietyOpt] = useState('');
    const [cropVariety, setCropVariety] = useState('');
    const [popDays, setPopDays] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    
    const [crrData, setCrrData] = useState('');
    const [tableData, setTableData] = useState('');
    const [viewModal, setViewModal] = useState('');

    useEffect(() => {
        get_crop_type();
    }, []);

    useEffect(() => {
        handleSearch(searchTerm);
    }, [tableData, searchTerm]);

    const get_crop_type = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_type_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.crop_type_id}> {row.crop_type_name}</option>
                    )
                });

                setCropTypeOpt(list);
            })
            .catch(error => {
                setLoading(false);
                let notify = notification({ message: "Failed to load crop types. Please try again.", type: 'error' });
                notify();
            });
    }

    const get_crop_list = (e) => {
        setCropOpt('');
        setCrop("0");
        setCropType(e.target.value);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "crop_type_id": e.target.value, "lang_id": 1 }];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.crop_code}> {row.crop_name}</option>
                    )
                });

                setCropOpt(list);
            })
            .catch(error => {
                setLoading(false);
                let notify = notification({ message: "Failed to load crops. Please try again.", type: 'error' });
                notify();
            });
    }

    const crop_variety_list = (e) => {
        setCrop(e.target.value);
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "crop_code": e.target.value, "lang_id": 1 }]
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_variety_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option key={index} value={row.crop_variety_code}> {row.crop_variety_name}</option>
                    )
                });

                setCropVarietyOpt(list);
            })
            .catch(error => {
                setLoading(false);
                let notify = notification({ message: "Failed to load crop varieties. Please try again.", type: 'error' });
                notify();
            });
    }

    const get_pop_list = async () => {
        setLoading(true);
        try {
            let postData = [{"org_id": sessionStorage.getItem('org_id')}];
            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/get_pop_list',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            let list = response.data.map((row, index) => {
                return {
                    ids: index + 1,
                    crop_detail: row.crop_name + " (" + row.crop_variety_name + ")", 
                    crop_name: row.crop_name,
                    variety_name: row.crop_variety_name,
                    pop_days: row.pop_days + " Days",
                    pop_days_numeric: row.pop_days,
                    action: (
                        <Button 
                            color='info' 
                            size="sm" 
                            outline
                            className="d-flex align-items-center gap-1"
                            onClick={() => {setCrrData(row); setMode(2);}}
                        >
                            <FaEye size={14} />
                            Details
                        </Button>
                    ),
                    rawData: row
                }
            });

            setTableData(list);
            setFilteredData(list);
            
            let notify = notification({ 
                message: `${list.length} POP records loaded successfully.`, 
                type: 'success' 
            });
            notify();
        } catch (error) {
            let notify = notification({ 
                message: "Failed to load POP list. Please try again.", 
                type: 'error' 
            });
            notify();
        } finally {
            setLoading(false);
        }
    }

    const create_new_pop = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            let postData = [{
                "org_id": sessionStorage.getItem('org_id'),
                "crop_code": crop,
                "crop_variety_code": cropVariety,
                "pop_days": popDays
            }];

            const response = await axios({
                method: 'post',
                url: mainurl + 'Traceability/create_pop',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            });

            if(response.data[0].retcode === "101"){
                let notify = notification({ 
                    message: "POP header created successfully.", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                get_pop_list();
                setViewModal(false);
                // Reset form
                setCropType('');
                setCrop('');
                setCropVariety('');
                setPopDays('');
                setCropOpt('');
                setCropVarietyOpt('');
            }
        } catch (error) {
            let notify = notification({ 
                message: "Failed to create POP. Please try again.", 
                type: 'error' 
            });
            notify();
        } finally {
            setLoading(false);
        }
    }

    // Search functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        if (!tableData || tableData.length === 0) return;
        
        if (value === '') {
            setFilteredData(tableData);
        } else {
            const filtered = tableData.filter(item =>
                item.crop_name.toLowerCase().includes(value.toLowerCase()) ||
                item.variety_name.toLowerCase().includes(value.toLowerCase()) ||
                item.crop_detail.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredData(filtered);
        }
    };

    const columns = [
        {
            name: '#',
            selector: row => row.ids,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaSeedling size={12} />
                    Crop Detail
                </div>
            ),
            selector: row => row.crop_detail,
            sortable: true,
            cell: row => (
                <div className="d-flex flex-column">
                    <strong className="text-primary">{row.crop_name}</strong>
                    <small className="text-muted">({row.variety_name})</small>
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    POP Days
                </div>
            ),
            selector: row => row.pop_days_numeric,
            sortable: true,
            center: true,
            cell: row => (
                <Badge 
                    color={row.pop_days_numeric > 120 ? 'success' : row.pop_days_numeric > 90 ? 'warning' : 'info'} 
                    pill
                >
                    {row.pop_days}
                </Badge>
            )
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '120px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Package Of Practice (POP)' breadcrumbs='Home / Package Of Practice (POP)'>
                {mode === 1 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            {/* Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col md={8}>
                                            <div className="d-flex gap-2">
                                                <Button 
                                                    color='primary' 
                                                    size="sm" 
                                                    onClick={get_pop_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaList size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load POP List'}
                                                </Button>
                                                <Button 
                                                    color='secondary' 
                                                    size="sm" 
                                                    onClick={() => setViewModal(true)}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    Add New POP
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <InputGroup size="sm">
                                                <InputGroupText className="bg-light border-end-0">
                                                    <FaSearch className="text-muted" />
                                                </InputGroupText>
                                                <Input
                                                    type="search"
                                                    placeholder='Search crops, varieties...'
                                                    value={searchTerm}
                                                    onChange={(e) => handleSearch(e.target.value)}
                                                    className="border-start-0"
                                                />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {Array.isArray(tableData) && tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="border-0 bg-primary text-white">
                                            <CardBody className="text-center py-3">
                                                <FaClipboardList size={24} className="mb-2" />
                                                <h5 className="mb-0">{tableData.length}</h5>
                                                <small>Total POP Records</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-success text-white">
                                            <CardBody className="text-center py-3">
                                                <FaSeedling size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(tableData.map(item => item.crop_name)).size}
                                                </h5>
                                                <small>Unique Crops</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-info text-white">
                                            <CardBody className="text-center py-3">
                                                <FaLeaf size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {new Set(tableData.map(item => item.variety_name)).size}
                                                </h5>
                                                <small>Crop Varieties</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="border-0 bg-warning text-white">
                                            <CardBody className="text-center py-3">
                                                <FaCalendarAlt size={24} className="mb-2" />
                                                <h5 className="mb-0">
                                                    {Math.round(tableData.reduce((sum, item) => sum + parseInt(item.pop_days_numeric), 0) / tableData.length)}
                                                </h5>
                                                <small>Avg. POP Days</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Main Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0">Package of Practice Records</h5>
                                            <small className='text-muted'>
                                                {Array.isArray(filteredData) && filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${Array.isArray(tableData) ? tableData.length : 0} records` :
                                                    'No POP records found'
                                                }
                                            </small>
                                        </div>
                                        {searchTerm && Array.isArray(filteredData) && (
                                            <Badge color="secondary" className="ms-2">
                                                Filtered: {filteredData.length}
                                            </Badge>
                                        )}
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {(!Array.isArray(tableData) || tableData.length === 0) && !loading ? (
                                        <Alert color="info" className="m-3 text-center">
                                            <FaClipboardList size={48} className="mb-3 text-muted" />
                                            <p className="mb-2">No POP records loaded yet</p>
                                            <small>Click "Load POP List" to fetch the latest package of practice data</small>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={custTableStyles}
                                            columns={columns}
                                            data={Array.isArray(filteredData) ? filteredData : []}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" />
                                                    <p className="mt-2 text-muted">Loading POP records...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3" />
                                                    <p className="text-muted">No POP records match your search criteria</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

                {mode === 2 && (
                    <AddNewPOP data={crrData} back={() => setMode(1)} />
                )}
            </Page>
            <Footer />

            {/* Enhanced Modal */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="modal-dialog-scrollable"
            >
                <ModalHeader 
                    toggle={() => setViewModal(!viewModal)}
                    className="bg-light border-bottom"
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaPlusCircle className="text-primary" />
                        <div>
                            <h5 className="mb-0">Add New Package of Practice</h5>
                            <small className="text-muted">Create a new POP record for crop management</small>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="p-4">
                    <Form onSubmit={create_new_pop}>
                        <Row>
                            <Col sm={6} className="mb-3">
                                <Label for="type" className="form-label fw-semibold">
                                    <FaSeedling className="me-2 text-primary" />
                                    Crop Type
                                </Label>
                                <Input 
                                    id="type" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={cropType} 
                                    onChange={get_crop_list}
                                    className="form-select"
                                >
                                    <option value="0">--Select Crop Type--</option>
                                    {cropTypeOpt}
                                </Input>
                            </Col>
                            <Col sm={6} className="mb-3">
                                <Label for="crop" className="form-label fw-semibold">
                                    <FaLeaf className="me-2 text-success" />
                                    Crop
                                </Label>
                                <Input 
                                    id="crop" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={crop} 
                                    onChange={crop_variety_list}
                                    className="form-select"
                                    disabled={!cropType || cropType === "0"}
                                >
                                    <option value="0">--Select Crop--</option>
                                    {cropOpt}
                                </Input>
                            </Col>
                            <Col sm={6} className="mb-3">
                                <Label for="cropVariety" className="form-label fw-semibold">
                                    <FaSeedling className="me-2 text-info" />
                                    Crop Variety
                                </Label>
                                <Input 
                                    id="cropVariety" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={cropVariety} 
                                    onChange={(e) => setCropVariety(e.target.value)}
                                    className="form-select"
                                    disabled={!crop || crop === "0"}
                                >
                                    <option value="0">--Select Crop Variety--</option>
                                    {cropVarietyOpt}
                                </Input>
                            </Col>
                            <Col sm={6} className="mb-3">
                                <Label for="popDays" className="form-label fw-semibold">
                                    <FaCalendarAlt className="me-2 text-warning" />
                                    POP Days
                                </Label>
                                <Input 
                                    id="popDays" 
                                    bsSize="sm" 
                                    type="number" 
                                    value={popDays} 
                                    onChange={(e) => setPopDays(e.target.value)}
                                    placeholder="Enter number of days"
                                    min="1"
                                    max="365"
                                />
                            </Col>
                        </Row>
                        <hr className="my-4" />
                        <div className="d-flex justify-content-end gap-2">
                            <Button 
                                type="button"
                                color="secondary" 
                                size="sm"
                                onClick={() => setViewModal(false)}
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                            <Button 
                                type="submit"
                                color='primary' 
                                size="sm"
                                disabled={loading || !cropType || !crop || !cropVariety || !popDays}
                                className="d-flex align-items-center gap-2"
                            >
                                {loading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <FaPlusCircle size={14} />
                                        Save POP
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default PackageOfPractice;